import firebase from 'firebase/app'
import { firebaseAction } from 'vuexfire'
import Vue from 'vue'

import {
  RECEIPT_API_ENDPOINTS,
} from '../../lib/url'

export default {
  createApiKey ({dispatch}, payload) {
    return new Promise((resolve, reject) => {
      firebase.auth().currentUser.getIdToken().then((token) => {
        const headers = {
          'Authorization': 'Bearer ' + token
        }
        if (process.env.VUE_APP_ENV !== 'production') {
          headers['Accept'] = 'application/vnd.quickreceipts.v0+json';
        }
        Vue.http.post(RECEIPT_API_ENDPOINTS.KEY_CREATE, payload, {headers}).then((response) => resolve(response.body)).catch((response) => reject(response.body))
      }).catch(() => dispatch('userSignOut'))
    })
  },
  editApiKey ({dispatch}, payload) {
    return new Promise((resolve, reject) => {
      firebase.auth().currentUser.getIdToken().then((token) => {
        const headers = {
          'Authorization': 'Bearer ' + token
        }
        if (process.env.VUE_APP_ENV !== 'production') {
          headers['Accept'] = 'application/vnd.quickreceipts.v0+json';
        }
        Vue.http.post(RECEIPT_API_ENDPOINTS.KEY_EDIT, payload, {headers}).then((response) => resolve(response.body)).catch((response) => reject(response.body))
      }).catch(() => dispatch('userSignOut'))
    })
  },
  deleteApiKey ({dispatch}, payload) {
    return new Promise((resolve, reject) => {
      firebase.auth().currentUser.getIdToken().then((token) => {
        const headers = {
          'Authorization': 'Bearer ' + token
        }
        if (process.env.VUE_APP_ENV !== 'production') {
          headers['Accept'] = 'application/vnd.quickreceipts.v0+json';
        }
        Vue.http.post(RECEIPT_API_ENDPOINTS.KEY_DELETE, payload, {headers}).then((response) => resolve(response.body)).catch((response) => reject(response.body))
      }).catch(() => dispatch('userSignOut'))
    })
  },

  syncReceipts: firebaseAction(({bindFirebaseRef, state}, {ref, callback}) => {
    if (state.receipts.data !== null) {
      (callback)(false)
      return
    }
    bindFirebaseRef('receipts', ref).then(() => {
      (callback)(true)
    })
  }),

  loadReceipts ({dispatch, commit, getters, state}, payload) {
    return new Promise((resolve, reject) => {
      firebase.auth().currentUser.getIdToken().then((token) => {
        const headers = {
          'Authorization': 'Bearer ' + token
        }
        if (process.env.VUE_APP_ENV !== 'production') {
          headers['Accept'] = 'application/vnd.quickreceipts.v0+json';
        }
        Vue.http.post(RECEIPT_API_ENDPOINTS.RECEIPT_LOAD, payload, {headers}).then((response) => resolve(response.body)).catch((response) => reject(response.body))
      }).catch(() => dispatch('userSignOut'))
    })
  },

  // updateApiUsage ({dispatch, commit, getters, state}, payload) {
  //   return new Promise((resolve, reject) => {
  //     resolve('')
  //   })
  // }
}
